export enum BackgroundLayerIdsEnum {
  GRAYSCALE = 'graatone',
  COLORS = 'farger',
  BASIC = 'grunnkart',
  RASTER = 'raster',
  NORWAY_PHOTOS = 'norgeibilder',
  NONE = 'ingen',
}
